// extracted by mini-css-extract-plugin
export var card = "_ml-0";
export var content = "_ml-2";
export var details = "_ml-3";
export var icon = "_ml-1";
export var iconBlue = "_ml-5";
export var iconBrand = "_ml-4";
export var iconGrayBlue = "_ml-6";
export var iconGreen = "_ml-7";
export var iconIndigo = "_ml-8";
export var iconOrange = "_ml-9";
export var iconPurple = "_ml-a";
export var iconRed = "_ml-b";
export var iconWarning = "_ml-c";